import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: calc(100vh - 85px);

  font-family: sans-serif;
  line-height: 1.5;
  outline: none;
`

const Icon = styled.div`
  width: 18px;
  height: 18px;
  margin-bottom: 1em;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    animation: spin 1s linear infinite;
    border-bottom-color: inherit;
    border-left-color: transparent;
    border-radius: 20rem;
    border-right-color: inherit;
    border-style: solid;
    border-top-color: inherit;
    border-width: 4px;
    color: #fa6400;
    display: block;
    height: 100%;
    position: relative;
    width: 100%;
  }

  @keyframes spin {
    0% {
      rotate: 0deg;
    }
    100% {
      rotate: 360deg;
    }
  }
`

export const Message = styled.div`
  color: #494b50;
  font-size: 0.8em;
  text-transform: uppercase;
`

export const Spinner = {
  Wrapper: Wrapper,
  Icon: Icon,
  Message: Message,
}
